// extracted by mini-css-extract-plugin
module.exports = {"text":"BigItemDescription_text__1ZIon"};